import { OHUtils } from './OHUtils';

export class OrgUnitUtils {
  static filterVisible<T extends { orgKey: string }>(orgUnits: T[]): T[] {
    return orgUnits.filter((ou) => !OHUtils.isOH(ou.orgKey));
  }
}
